<template lang="pug">
v-container
  h1 Настройка автоответов
  v-tabs(v-model="selectedTab")
    v-tab(v-for="(tab, idx) in tabs" :key="idx") {{tab.name}}
  v-tabs-items(v-model="selectedTab")
    v-tab-item(v-for="(tab, idx) in tabs" :key="idx")
      component(:is="tab.component") {{tab.name}}

</template>
<script>
import keyWords from './components/KeyWords.vue';
// import autoAnswerService from '@/services/API/autoAnswer';
import Questions from './components/Questions.vue';

export default {
  name: 'AutoAnsewerSettings',
  data() {
    return {
      selectedTab: 0,
      tabs: [
        {
          name: 'Ключевые слова',
          component: keyWords,
        },
        {
          name: 'Типовые вопросы',
          component: Questions,
        },
      ],
      loading: true,
      keyWords: [],
    };
  },

  methods: {

  },
};
</script>
